<template>
  <div class="page feedback">
    <navigation>反馈评价</navigation>
    <div class="title">问题截图（选填）</div>
    <div class="content">
      <nd-input
        name="content"
        v-model="form.content"
        label=""
        placeholder="请输入您发现的问题"
        type="textarea"
        rows="4"
        :autoSize="false"
      >
      </nd-input>
    </div>
    <div class="title">问题截图（选填）</div>
    <div class="content">
      <upload
        name="evidenceImageUrls"
        :images.sync="form.evidenceImageUrls"
        :limit="3"
      ></upload>
    </div>
    <nd-button
      class="btn"
      @click="serviceVisible=true"
      style="background: linear-gradient( 270deg, #FF9551 0%, #FB571C 100%);"
    >提交反馈</nd-button>
  </div>
</template>

<script>
export default {
  components: {
    upload: () => import('../components/upload')
  },
  data () {
    return {
      serviceVisible: false,
      form: {
        evidenceImageUrls: []
      }
    }
  },
  mounted () {
    this.$bus.$emit('ready')
  },
  methods: {}
}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.feedback {
  background: #f7f7f7;
  .title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 32px;
    color: #333333;
    line-height: 45px;
    text-align: left;
    font-style: normal;
    margin: 50px 30px 16px;
  }
  .content {
    background: #fff;
    margin: 0 30px;
    border-radius: 20px;
    padding: 40px;
  }
  .btn {
    position: absolute;
    left: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    bottom: 40px;
  }
}
</style>